import React from 'react'
import { PMPBodySectionItems } from './styledComponent'
import { PRESCRIPTION_COLORS_MAP } from '../../../inputComponents/common/color-utils'
import { getCasedHeadingTextBasedOnStyleOverrides } from './util'
import { getSectionListFormatConfig, renderSectionLabelList } from './sectionListFormat'

export default function PrintableInstructions({
  instructionsRef,
  debug,
  debugHighlightStates,
  selectedInstructions,
  styleOverrides,
  listItemSeparator,
}) {
  // Instructions historically render as bullets — keep that as the default.
  const listCfg = getSectionListFormatConfig(styleOverrides, listItemSeparator, { defaultBullet: true })
  return (
    <PMPBodySectionItems
      borderLeft={styleOverrides?.borderLeft}
      paddingLeft={styleOverrides?.paddingLeft}
      ref={instructionsRef}
      debug={debug}
      debugColor={PRESCRIPTION_COLORS_MAP.instructions?.color}
      debugHighlight={debugHighlightStates?.instructions}
    >
      <span
        style={{
          fontSize: styleOverrides?.headingFontSize
            ? `${styleOverrides?.headingFontSize}px`
            : 'inherit',
          color: styleOverrides?.headingColor || styleOverrides?.color || 'inherit',
          fontWeight: 600,
        }}
      >
        <strong>
          {getCasedHeadingTextBasedOnStyleOverrides({
            headingText: 'Advised Instructions',
            styleOverrides,
          })}
        </strong>
      </span>
      <div
        style={{
          fontSize: styleOverrides?.fontSizePixels
            ? `${styleOverrides?.fontSizePixels}px`
            : 'inherit',
          color: styleOverrides?.color || 'inherit',
          wordWrap: 'break-word',
          wordBreak: 'break-word',
          overflowWrap: 'break-word',
          maxWidth: '100%',
        }}
      >
        {renderSectionLabelList(selectedInstructions, listCfg)}
      </div>
    </PMPBodySectionItems>
  )
}
